/* eslint-disable brace-style */
/* eslint-disable no-restricted-syntax */

// In : src/providers/FormDataProviders.ts
import {
  AbstractFragmentTranslator,
  DivisionsProviderInterface,
  FormDataProvidersInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { FragmentTranslatorContract } from "@totalenergiescode/mobility-business-rev-form-data/components";
import {
  GetLedgerCreationDataInterface,
  GetLedgerModificationDataInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import {
  CreateLedgerOrderInterface,
  CreateLedgerOrderRequest,
  OrderData,
  UpdateLedgerOrderInterface,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import { DecoratorStore } from "@totalenergiescode/mobility-business-rev-form-data/store";
import { GraphQLClient } from "graphql-request";
import { TFunction } from "i18next";

import { GetLedgerCreationData } from "@/api/graphql/ledgers/getCreationTemplate/api";
import { GetLedgerModificationData } from "@/api/graphql/ledgers/getModificationTemplate/api";
import { registerCommonDecorators } from "@/components/FormData/lib/decorators/register.common";
import { DivisionsFaker } from "@/components/FormData/providers/formData/adapters/divisions.faker";
import {
  DriverCodeValidatorInterface,
  DriverCodeValidatorResponse,
} from "@/components/FormData/providers/formData/adapters/drivers";

// My implementation of the translator using react-i18next
export class I18nTranslator
  extends AbstractFragmentTranslator
  implements FragmentTranslatorContract
{
  constructor(private t: TFunction) {
    super();
  }

  translate(fragment: string, params?: object): string {
    return this.t(fragment, params as any) as string;
  }

  resolveTranslationKeys(fragment: string): string[] {
    return [fragment];
  }

  maybeTranslate(fragment: string, params?: object): string | null {
    const result = this.t(fragment, { ...params, defaultValue: null } as any);

    return result !== fragment ? (result as string) : null;
  }
}

// Simple implementation of the driver code validator
class DriverCodeValidator implements DriverCodeValidatorInterface {
  async validateDriverCode(
    value: string,
  ): Promise<DriverCodeValidatorResponse> {
    // Simple implementation: check that the code is not empty
    // TODO: Add your business validation logic here
    return {
      valid: value.length > 0,
      failedReason:
        value.length > 0 ? undefined : ("Driver code is required" as any),
    };
  }
}

// Simple implementation to create a ledger order
class CreateLedgerOrder implements CreateLedgerOrderInterface {
  constructor(_graphqlClient: GraphQLClient) {}

  async create(_request: CreateLedgerOrderRequest): Promise<OrderData> {
    // TODO: Implement the GraphQL call to create a ledger order
    throw new Error("Not implemented yet");
  }
}

// Simple implementation to update a ledger order
class UpdateLedgerOrder implements UpdateLedgerOrderInterface {
  constructor(_graphqlClient: GraphQLClient) {}

  async update(
    _accountId: string,
    _ledgerId: string,
    _templateId: string,
    _serializedData: Record<string, string>,
  ): Promise<OrderData> {
    // TODO: Implement the GraphQL call to update a ledger order
    throw new Error("Not implemented yet");
  }
}

// My full implementation
export class FormDataProviders implements FormDataProvidersInterface {
  translator: FragmentTranslatorContract;
  validators: { driverCode: DriverCodeValidatorInterface };
  divisions: DivisionsProviderInterface;
  creationTemplate: GetLedgerCreationDataInterface;
  createLedgerOrder: CreateLedgerOrderInterface;
  modificationTemplate: GetLedgerModificationDataInterface;
  updateLedgerOrder: UpdateLedgerOrderInterface;
  decorators: DecoratorStore;
  constructor(t: TFunction, _graphqlClient: GraphQLClient) {
    this.translator = new I18nTranslator(t);
    this.validators = {
      driverCode: new DriverCodeValidator(),
    };
    this.divisions = new DivisionsFaker();
    this.creationTemplate = new GetLedgerCreationData(_graphqlClient);
    this.modificationTemplate = new GetLedgerModificationData(_graphqlClient);
    this.createLedgerOrder = new CreateLedgerOrder(_graphqlClient);
    this.updateLedgerOrder = new UpdateLedgerOrder(_graphqlClient);
    this.decorators = new DecoratorStore(registerCommonDecorators);
  }
}
